import { useState } from 'react';

export default function SubscribeBar() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubscribe = () => {
    if (!email.trim()) {
      setIsError(true);
      setMessage('请先填写邮箱地址，再订阅每日更新。');
      return;
    }
    setIsError(false);
    setMessage('已记录，我们会把整理好的每日更新推送到这个邮箱。');
    setEmail('');
  };

  return (
    <section id="subscribe" className="bg-background-50 py-10 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-primary-600 px-6 py-8 md:px-10 md:py-12">
          <div className="pointer-events-none absolute -top-16 -right-10 w-56 h-56 rounded-full bg-accent-500/40 blur-3xl"></div>
          <div className="pointer-events-none absolute -bottom-20 left-1/3 w-56 h-56 rounded-full bg-secondary-500/30 blur-3xl"></div>

          <div className="relative grid lg:grid-cols-2 gap-7 md:gap-10 items-center">
            <div>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs font-label">
                <i className="ri-mail-send-line"></i>
                每日更新推送
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug text-balance">
                不想错过新瓜？<br className="hidden md:block" />
                让脉络自己找上门
              </h2>
              <p className="mt-3 text-sm text-background-50/85 leading-relaxed max-w-md">
                每天把新增的爆料、回应与时间线变动汇总成一封，只发真正推进了的信息，不发重复的热搜噪音。
              </p>
            </div>

            <div>
              <div className="flex flex-col sm:flex-row gap-2">
                <label className="flex-1 flex items-center gap-2.5 h-12 px-4 rounded-md bg-background-50">
                  <i className="ri-at-line text-primary-500 text-lg"></i>
                  <input
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="输入你的邮箱地址"
                    className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
                  />
                </label>
                <button
                  type="button"
                  onClick={handleSubscribe}
                  className="h-12 px-6 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-1.5"
                >
                  <i className="ri-notification-3-line"></i>
                  订阅每日更新
                </button>
              </div>
              {message && (
                <p
                  className={
                    isError
                      ? 'mt-3 text-sm text-background-50 flex items-center gap-1.5'
                      : 'mt-3 text-sm text-background-50/90 flex items-center gap-1.5'
                  }
                >
                  <i className={isError ? 'ri-error-warning-line' : 'ri-check-line'}></i>
                  {message}
                </p>
              )}
              <p className="mt-2 text-xs text-background-50/70">
                演示页面，提交不会真正发送邮件。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}